import React from "react";
import { useNavigate } from "react-router";
import { Button, Grid, Paper, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { CourseCard } from "../../../entities/components/CourseCard";
import Course1 from "../../../shared/images/Course-1.png";
import Course2 from "../../../shared/images/Course-2.png";
import Course3 from "../../../shared/images/Course-3.png";

import "../Report.scss";
import useCoursesStore from "../../../store/useCoursesStore";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../../store/useAuthStore";
import { capitalizeFirstLetter } from "../../../utils/helpers";
import { OnboardingTour } from "@gfazioli/mantine-onboarding-tour";

export const EssentialSkillCourses: React.FC = () => {
  const laptop = useMediaQuery("(max-width: 1100px)");
  const mobile = useMediaQuery("(max-width: 820px)");
  const navigate = useNavigate();

  const images = [Course1, Course2, Course3];
  const {
    recommendedCourses,
    learningCourses,
    fetchLearningCourses,
    addLearningCourses,
    removeLearningCourse,
    setCurrentTab,
  } = useCoursesStore();

  const { access_token } = useAuthStore();

  const { t } = useTranslation();

  const handleOnClick = async (id: number) => {
    const course = learningCourses.results.find(
      (learningCourse) => learningCourse.course.id === id
    );
    const exist = learningCourses.results.some(
      (learningCourse) => learningCourse.course.id === id
    );

    if (exist && access_token) {
      await removeLearningCourse(course?.id!, id);
      fetchLearningCourses();
    } else if (!exist && access_token) {
      await addLearningCourses(id);
      fetchLearningCourses();
    }
  };
  const matches = useMediaQuery("(max-width: 1100px)");

  const handleCategoryClick = (category: string, topic?: string) => {
    const url = topic
      ? `/courses?category=${encodeURIComponent(
          category
        )}&topic=${encodeURIComponent(capitalizeFirstLetter(topic))}`
      : `/courses?category=${encodeURIComponent(category)}`;

    navigate(url);
  };

  if (mobile) {
    return (
      <Paper radius="24px" p="32px" mt={32} withBorder>
        <OnboardingTour.Target id="recommended-courses-section">
          <Title size={matches ? 24 : 36} mb={8}>
            {t("relevant_courses_title")}
          </Title>
        </OnboardingTour.Target>
        <Text style={{ fontSize: matches ? 16 : 18 }} mb={24} c="#6F40E2">
          {t("relevant_courses_description")}
        </Text>
        <Grid>
          {recommendedCourses.results.slice(0, 3).map((course, index) => (
            <Grid.Col span={mobile ? 12 : laptop ? 6 : 4} key={index}>
              <CourseCard
                id={course.id}
                image={
                  course.image ? course.image : images[index % images.length]
                }
                platform={course.platform}
                title={course.title}
                authors={course.authors}
                description={course.description}
                rating={course.rating ?? "Unrated"}
                handleOnClick={handleOnClick}
                url={course.url}
                isLearning={course.is_in_learnings}
                category={course.category}
                topics={course.topics}
                languages={course.languages}
                organization={course.organization}
                price={course.price}
                currency={course.currency}
                is_free={course.is_free}
                onCategoryClick={handleCategoryClick}
              />
            </Grid.Col>
          ))}
        </Grid>
        <Button
          variant="outline"
          maw={matches ? 277 : undefined}
          mt={24}
          onClick={() => {
            navigate("/courses");
            setCurrentTab("Recommended");
          }}
        >
          {t("view_all_recommended_courses")}
        </Button>
      </Paper>
    );
  }
  return (
    <Paper radius="24px" p="32px" mt={32} withBorder>
      <Title size={matches ? 24 : 36} mb={8}>
        {t("relevant_courses_title")}
      </Title>
      <Text style={{ fontSize: matches ? 16 : 18 }} mb={24} c="#6F40E2">
        {t("relevant_courses_description")}
      </Text>
      <OnboardingTour.Target id="recommended-courses-section">
        <Grid style={{ borderRadius: "15px" }}>
          {recommendedCourses.results.slice(0, 3).map((course, index) => (
            <Grid.Col span={mobile ? 12 : laptop ? 6 : 4} key={index}>
              <CourseCard
                id={course.id}
                image={
                  course.image ? course.image : images[index % images.length]
                }
                platform={course.platform}
                title={course.title}
                authors={course.authors}
                description={course.description}
                rating={course.rating ?? "Unrated"}
                handleOnClick={handleOnClick}
                url={course.url}
                isLearning={course.is_in_learnings}
                category={course.category}
                topics={course.topics}
                languages={course.languages}
                organization={course.organization}
                price={course.price}
                currency={course.currency}
                is_free={course.is_free}
                onCategoryClick={handleCategoryClick}
              />
            </Grid.Col>
          ))}
        </Grid>
      </OnboardingTour.Target>
      <Button
        variant="outline"
        maw={matches ? 277 : undefined}
        mt={24}
        onClick={() => {
          navigate("/courses");
          setCurrentTab("Recommended");
        }}
      >
        {t("view_all_recommended_courses")}
      </Button>
    </Paper>
  );
};
